import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

import CatalogSelectReservationDateStep from 'components/Catalog/CatalogSelectReservationDateStep';
import HintMessage from 'components/HintMessage';
import BbForm from 'common/components/BbForm';
import BbField from 'common/components/BbField';
import currency from 'common/filters/currency';

import CatalogReservationConfig from 'assets/graphql/queries/catalog/CatalogReservationConfig.graphql';

Vue.filter('currency', currency);

@Component({
  components: {
    CatalogSelectReservationDateStep,
    HintMessage,
    BbForm,
    BbField,
  },
  props: {
    activityId: {
      type: String,
      required: true,
    },
    tabs: {
      type: Array,
      required: true,
    },
    expirationDate: {
      type: String,
      required: true,
    },
    code: {
      type: [String, Object],
      required: false,
    },
    codeId: {
      type: Number,
      required: false,
    },
    codeExpirationDate: {
      type: String,
      required: false,
    },
    locations: {
      type: Array,
      required: true,
    },
    isReservationBuy: {
      type: Boolean,
      required: false,
      default: false,
    },
    showAddToCartButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    activity: {
      type: Object,
      required: false,
    },
  },
  apollo: {
    reservationConfig: {
      query: CatalogReservationConfig,
      variables() {
        return {
          partneractivity_id: this.activityId,
          location_id: this.location.id,
        };
      },
      // wait until default location is selected
      skip() {
        return !this.location;
      },
      update(data) {
        this.$emit('reservationConfigLoaded', data.reservation_config);
        return data.reservation_config;
      },
    },
  },
})
export default class CatalogSelectReservationLocationStepComponent extends Vue {
  errors = [];
  location = null;
  form = {
    date: null,
    appointment: null,
  };

  @Watch('locations', { immediate: true })
  setDefaultLocation(newVal) {
    if (newVal.length >= 1) this.location = newVal[0].location;
  }

  @Watch('location')
  async fetchReservationConfig() {
    await this.$apollo.queries.reservationConfig.refetch();
  }

  submitForm() {
    this.$emit('selectDateCompleted', {
      ...this.form,
      location: this.location,
    });
  }

  isLoading() {
    this.$emit('isLoading', !this.location);
  }

  addToCart() {
    this.$emit('addToCart');
  }

  get formIsNotCompleted() {
    return (
      this.form.date === null ||
      !this.location ||
      this.form.appointment === null
    );
  }

  get canContinue() {
    return !Object.values(this.form).some(value => !value);
  }
}
